
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    error: Boolean
  }
})
